import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../shadcn/dialog'

export interface ModalProps {
  open: boolean
  title: string
  description?: string
  onClose: () => void
  children: React.ReactNode
  footer?: React.ReactNode
  width?: 'narrow' | 'medium' | 'wide'
}

const WIDTHS: Record<NonNullable<ModalProps['width']>, string> = {
  narrow: 'sm:max-w-md',
  medium: 'sm:max-w-lg',
  wide: 'sm:max-w-2xl',
}

/** Thin wrapper around shadcn Dialog so older callers keep their API. */
export function Modal({
  open,
  title,
  description,
  onClose,
  children,
  footer,
  width = 'medium',
}: ModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose()
      }}
    >
      <DialogContent className={`${WIDTHS[width]} max-h-[85vh] overflow-y-auto`}>
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-normal tracking-tight">
            {title}
          </DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        <div className="text-sm">{children}</div>
        {footer ? <DialogFooter>{footer}</DialogFooter> : null}
      </DialogContent>
    </Dialog>
  )
}
